(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/actions/remove-item.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/actions/remove-item.js');
"use strict";


const removeItem = callback => (id, callbackFn, timeout) => {
  callback(id, callbackFn, timeout);
};
setGlobal('svs.components.selfserviceCart.fns.actions.removeItem', removeItem);

 })(window);